import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { KriyaLab } from '@/prakrit/components/grammar/labs/kriya-lab'

const KriyaPage: FC = (): ReactNode => (
    <Layout>
        <Seo
            title='Dhātu laboratory'
            description='धातुरूप प्रयोगशाला: choose a Prakrit root, tense, person and number and watch every form built by rule, used in a sentence and compared across tenses.'
        />
        <KriyaLab />
    </Layout>
)

export default KriyaPage
